<template>
  <div class="evaluationWrap" v-if="doctorInfo">
    <div class="card">
      <div class="card_top">
        <div>
          <div class="title">
            请对 {{ doctorName || doctorInfo.username }} 医生的本次问诊服务进行评价
          </div>
          <div class="subTitle">请按照患者的评价填写</div>
        </div>
        <auth-img src="@/assets/img/evaluation.png" alt="" />
      </div>
      <div class="card_bottom" @click="goRate(props.info)">查看详情</div>
    </div>
    <ConRate
      ref="RateVisible"
      v-model:isNeedRate="isNeedRate"
      @refresh="() => {}"
      :canRate="props.canRate"
    />
  </div>
</template>

<script setup>
import { ref, defineProps, computed } from 'vue'
import { useStore } from 'vuex'
import ConRate from '@/components/com-rate'

const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  doctorName: {
    type: String,
    default: ''
  },
  canRate: {
    type: Boolean,
    default: true
  }
})

const store = useStore()
const doctorInfo = computed(() => store.state.workOrder.workOrderGroupInfo.doctorInfo)

const isNeedRate = ref(false)
const RateVisible = ref(null)
const goRate = card => {
  console.log(card)
  const keyId = card?.msg?.evaluationId || card?.bodies?.evaluationId
  RateVisible.value.rate.visible = true
  RateVisible.value.rate.evaluationId = keyId
  RateVisible.value.EvaluationMethod(keyId)
}
</script>
<style lang="scss" scoped>
.evaluationWrap {
  display: flex;
  justify-content: center;
  .card {
    background-color: #fff;
    width: 432px;
    height: 240px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    &_top {
      flex: 1;
      margin: 12px 12px 0;
      background-color: rgba(152, 215, 255, 0.15);
      display: flex;
      .title {
        width: 210px;
        height: 44px;
        font-weight: 500;
        font-size: 16px;
        color: #1a1a1a;
        margin: 38px 0 0 15px;
      }
      .subTitle {
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 15px;
      }
      img {
        display: block;
        width: 156px;
        height: 127px;
        margin: 15px 0 0 17px;
      }
    }
    &_bottom {
      height: 56px;
      line-height: 56px;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      color: #3f64ff;
      cursor: pointer;
    }
  }
}
</style>
